import type { SystemStyleObject } from "@ecco/ui/theme-tools";
import { focusOutline } from "@ecco/ui/css/focus";

const baseStyle: SystemStyleObject = {
    fontSize: "desktopBodyTextNormal",
    transitionProperty: "common",
    transitionDuration: "normal",
    minW: 40,
    zIndex: 1,
    w: ["50%", "fit-content"],
    _focusVisible: {
        ...focusOutline,
    },
    _hover: {
        background: "gray.200",
    },
    _active: {
        background: "gray.200",
    },
};

export const topFilterStyles: SystemStyleObject = {
    ...baseStyle,
    fontWeight: "bold",
    justifyContent: "space-between",
    backgroundColor: "white",
    _hover: {
        background: "gray.100",
        color: "black",
    },
    _active: {
        background: "white",
    },
};

export const subFilterStyles: SystemStyleObject = {
    ...baseStyle,
    justifyContent: "space-between",
};

export const commonFilterStyles: SystemStyleObject = {
    height: [10, 10],
    bgColor: "white",
    backdropFilter: `blur(7.5px)`,
    shadow: "base",
    paddingLeft: 4,
    paddingRight: 4,
    _focus: { shadow: "base" },
    _active: { shadow: "base" },
    "*": {
        pointerEvents: "none",
    },
};
